import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
// import { Markup } from 'interweave';
import { FaUserTimes } from "react-icons/fa";

import { useStartKyc } from "@/api/mutations";
import { useGetKycStatus } from "@/api/queries";
import FormError from "@/components/FormError";
import H2 from "@/components/H2";
import RebrandPrimaryButton from "@/components/RebrandPrimaryButton";
import Spacer from "@/components/Spacer";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

import SecurityFailedExpired from "./securityFailedMessages/SecurityFailedExpired";
import SecurityFailedIncorrectDocument from "./securityFailedMessages/SecurityFailedIncorrectDocument";
import SecurityFailedInvalidDocument from "./securityFailedMessages/SecurityFailedInvalidDocument";
import SecurityFailedNoRetries from "./securityFailedMessages/SecurityFailedNoRetries";
import SecurityFailedNotSupported from "./securityFailedMessages/SecurityFailedNotSupported";
import SecurityFailedPicture from "./securityFailedMessages/SecurityFailedPicture";
import SecurityFailedGeneric from "./securityFailedMessages/SecurityFailureGeneric";

function SecurityFailed() {
  const { t } = useTranslation("security");
  const kycStatus = useGetKycStatus();
  const [gettingKyc, setGettingKyc] = useState(true);
  let message = null;
  const navigate = useNavigate();
  const [mutationErrorMessage, setMutationErrorMessage] = useState("");
  const [validationErrorMessage, setValidationErrorMessage] = useState("");

  switch (kycStatus?.data?.kycStatus) {
    case 7:
      console.log("kycStatus", kycStatus?.data?.restartkyc);
      if (kycStatus?.data?.restartkyc === false) {
        message = <SecurityFailedNoRetries />;
      }
      else {
        message = <SecurityFailedGeneric />;
      }
      break;
    case 5:
      message = <SecurityFailedExpired />;
      break;
    case 9:
      message = <SecurityFailedPicture />;
      break;
    case 10:
      message = <SecurityFailedNotSupported />;
      break;
    case 11:
      message = <SecurityFailedInvalidDocument />;
      break;
    case 12:
      message = <p>{t("security:security-status-failed-country-mismatch")}</p>;
      break;
    case 13:
      message = (
        <p>{t("security:security-status-failed-duplicate-verification")}</p>
      );
      break;
    case 14:
      message = <SecurityFailedIncorrectDocument />;
      break;
    default:
      message = <p>{t("security:security-failed-text")}</p>;
      break;
  }

  const startKycStatusMutation = useStartKyc();

  // const kyc = AppState.useState(s => s?.kyc);
  const kyc = useAppStore(s => s.kyc);
  if (kyc?.messages && kyc.messages.length > 0 && kyc.messages[0] === "KYC still pending") {
    navigate({ to: "/security/begin-security-check" });
  }

  const beginKyc = () => {
    setGettingKyc(true);
    startKycStatusMutation.reset();
    setMutationErrorMessage("");
    setValidationErrorMessage("");
    startKycStatusMutation.mutate(null, {
      onSuccess: (res) => {
        if (res?.kycpassed === true) {
          setValidationErrorMessage("Security Check Already Completed");
        }
        else {
          navigate({ to: "/security/begin-security-check" });
        }
        setGettingKyc(false);
      },
      onError: (error) => {
        setMutationErrorMessage(error.message);
        setGettingKyc(false);
        // AppState.update((s) => {
        //   s.navItemsEnabled = true;
        // });
        useAppStore.setState({ navItemsEnabled: true });
        console.log("start kyc error", error);
      },
    });
  };

  return (
    <div className="flex flex-wrap">
      <div className="w-full h-screen lg:min-h-screen-minus-header">
        <div className="mx-4 my-12 lg:mx-12 xl:mx-20 2xl:mx-40">
          <div className="text-center lg:text-left">
            <H2>{t("security:security-check-header")}</H2>
          </div>
          <Spacer />
          <div className="flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg whitespace-pre-wrap security-text-container grid grid-flow-col grid-auto-columns: minmax(0, 2fr);">
              <div className="flex flex-col items-center">
                <div className="flex flex-col items-center">
                  <div className="mb-6 security-icon">
                    <FaUserTimes />
                  </div>
                  <div className="html-content font-sentric-alt">{message}</div>
                </div>
                {kycStatus?.data?.restartkyc ? (
                  <div className="mt-12">
                    <RebrandPrimaryButton

                      disabled={!gettingKyc}
                      onClick={() => beginKyc()}
                      arrow
                    >
                      {t("security:security-restart-button")}
                    </RebrandPrimaryButton>
                  </div>
                ) : (
                  <div className="mt-12">
                    <RebrandPrimaryButton
                      disabled={!gettingKyc}
                      onClick={() => navigate({ to: "/" })}
                      arrow
                    >
                      {t("other:go-to-dashboard")}
                    </RebrandPrimaryButton>
                  </div>
                )}
              </div>
            </div>
          </div>
          <FormError
            mutationError={mutationErrorMessage}
            validationError={validationErrorMessage}
          />
        </div>
      </div>
    </div>
  );
}
export default SecurityFailed;
